var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 8,
    viewBox: "0 0 85 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H77C81.4183 0 85 3.58172 85 8H0Z",
    fill: "#003399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentTabIcon);
export default __webpack_public_path__ + "static/media/CurrentTabIcon.3ab57b1ba79e897551fbf9fdda9757a1.svg";
export { ForwardRef as ReactComponent };